import { render, staticRenderFns } from "./userLevel.vue?vue&type=template&id=1ae45478&"
import script from "./userLevel.vue?vue&type=script&lang=js&"
export * from "./userLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports